import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRightIcon, FlaskConicalIcon } from "lucide-react";

interface EnhancedProcessingStepsCardProps {
  steps: string[];
}

export default function EnhancedProcessingStepsCard({
  steps,
}: EnhancedProcessingStepsCardProps) {
  return (
    <Card className="shadow-lg h-full border border-slate-200 rounded-xl overflow-hidden">
      <CardHeader className="pb-3 pt-5 px-6">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <FlaskConicalIcon size={20} className="text-indigo-600" />
          Suggested Way of Processing
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="flex flex-wrap items-center gap-2">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center">
              <div className="bg-slate-100 px-3 py-1.5 rounded-md border border-slate-200 shadow-sm">
                <span className="text-base font-medium text-slate-700">
                  {step}
                </span>
              </div>
              {index < steps.length - 1 && (
                <ArrowRightIcon className="mx-2 text-slate-500" size={18} />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
